<template>
	<div id="StepWizardTestimony" class="text-left">
		<div class="title-area">
			<h4>{{ stepName }}</h4>
			<p>
				Selecione até três comentários que falem bem de você ou do seu produto.
			</p>
		</div>
		<div class="input-area">
			<masonry :cols="{ default: 3, 1000: 3, 700: 2 }" :gutter="8">
				<div
					class="my-2"
					@click="handleTestimony(index)"
					v-for="(testimony, index) in listTestimonies"
					:key="index"
				>
					<Testimony :comment="testimony" />
				</div>
			</masonry>
		</div>
	</div>
</template>

<script>
	import axios from "axios";

	import Testimony from "@/components/Testimony";
	import BaseImage from "@/components/atoms/BaseImage";
	import apiMixins from "@/mixins/apiMixins";
	export default {
		name: "StepWizardTestimony",
		props: {
			stepName: {
				type: String,
				required: false,
			},
			stepDirt:{
				type: Boolean,
				default: false,
			},
			orientation:{
				type: String,
			}
		},
		mixins: [apiMixins],
		components: {
			Testimony,
			BaseImage,
		},
		async created() {
			// this.$store.dispatch("GET_TESTIMONIES");
			this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [true]);
			if(this.$store.state.wizard.dataSite.testimonies.length == 0){
				const token = localStorage.getItem("jwt");
				const siteId = localStorage.siteId;
				const url = `/site/${siteId}/wizard/comments`;
				const testimonies = await this.requestApiData(url, "get");
				if (testimonies.data.length > 0) {
						this.$store.dispatch("WIZARD_UPDATE_TESTIMONIES", [testimonies.data]);
				} else {
					if(this.orientation == "foward"){
						this.$emit("nextStep");
					}else{
						this.$emit("trigger-back-step");
					}
				}
			}
			this.handleBottonButtons()
		},
		mounted(){
			this.$emit("updateStep");
		},
		computed: {
			listTestimonies() {
				return this.$store.state.wizard.dataSite.testimonies;
			},
		},
		methods: {
			handleTestimony(index) {
				this.$store.dispatch("UPDATE_TESTIMONIES", [index]);
				this.handleBottonButtons()
			},
			handleBottonButtons(){
				if (this.listTestimonies.length == 0) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
				}
				const selectedTestimonies = this.$store.state.wizard.dataSite.testimonies.filter(element => element.save_comment == true);
				if (selectedTestimonies.length >= 1) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
				} else if (selectedTestimonies.length == 0) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
				}
				if (selectedTestimonies.length >= 3) {
					if(this.stepDirt == false){
						this.$store.dispatch("WIZARD_COMPLETE_STEP", [this.stepName]);
						this.$emit("nextStep");
					}
				}
			}
		},
	};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardTestimony.vue